<div class="strategy-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 order-lg-2">
                <div class="strategy-image">
                    <img src="assets/img/premio.jpg" alt="image" loading="lazy">
                </div>
            </div>
            <div class="col-lg-6 col-md-12 order-lg-1">
                <div class="strategy-content justify-content-around">
                    <div class="section-title">
                        <!--<h4>Highly Creative Solutions</h4>-->
                        <h2>Nuestros <span>Reconocimientos</span></h2>
                        <p>En sus 25 años de trayectoria, este centro ha obtenido numerosos reconocimientos.</p>
                    </div>
                    <ul class="features-list">
                        <li><i class="fas fa-check"></i>Investigaciones destacables sobre la infancia en contextos
                            adversos, las cuales se remontan al año 1977.</li>
                        <li><i class="fas fa-check"></i>Participó en dos convocatorias de Reconocimiento
                            de Centros en 1996 y el 2000.</li>
                        <li><i class="fas fa-check"></i>En 2011 participó en la elaboración de documentos
                            para la política dirigida a niñez de <b>Cero a Siempre</b>.</li>
                        <li><i class="fas fa-check"></i>En 2019 Minciencias otorgó a este centro el título de <b>Centro
                                de Investigaciones del Sistema Nacional de Ciencia, Tecnología e Innovación</b></li>
                        <!--<li><i class="fas fa-check"></i>Modern Design</li>
                        <li><i class="fas fa-check"></i>Awesome Design</li>
                        <li><i class="fas fa-check"></i>Digital Marketing & Branding</li>-->
                    </ul>                    
                    <p>En cuanto a su contribución científica entre el periodo 2018 y 2021, <b>el Centro ha 
                        generado 115 artículos científicos, 112 capítulos de libros y 40 libros</b>, muchos de 
                        los cuales han recibido un alto nivel de citaciones. </p>
                </div>
            </div>
        </div>
    </div>
    <div class="shape1"><img src="assets/img/shape1.png" alt="image"></div>
</div>
